import { Button, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import WsC from './providers/WsC';


export default class ChestionarNou extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            titlu: '',
            alertView:false
        }
    }

    componentDidMount() {
        this.access()
    }

    u = new Utils()
    ws = new WsC()
    ls = new LocalStorage()

    access = async () => {



        // console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.GetUserData().InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.GetUserData().InfoUser.EsteSef === 1 ? false : true })
        }


    }

    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }




    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }

    insertIntrebare = async (idChestionar) => {



        let ws = new WsC();

        let objToInsert = {
            id_chestionar: idChestionar,
            tip: 'radio',
            id_categorie: 1,
            intrebare: '',


        }


        let insertIntrebare = await ws.insert('chestionare_intrebari', objToInsert)

        if (insertIntrebare.Succes) {

            objToInsert.id = insertIntrebare.Content[0].id

            let raspuns = { label: '', id_intrebare: insertIntrebare.Content[0].id }

            let raspunsuri = ['', '', '']

            for (let i = 0, n = raspunsuri.length; i < n; i++) {
                raspuns.label = raspunsuri[i]
                await ws.insert('chestionare_intrebari_optiuni_raspuns', raspuns)
            }

        }

    }


    addChestionar = async () => {


        console.log('this.ls.GetUserData() :>> ', this.ls.GetUserData());
        let chestionar = {


            id_beneficiar:1,
            creat_de: this.ls.GetUserData().InfoUser.IdUser,
            creat_la: this.u.defaultData(),
            // database:this.ls.GetUserData().InfoUser.Database,
            nume: this.state.titlu,
            statusul: 'in_lucru',
            titlu:this.state.titlu,
            baza_date:this.ls.GetUserData().InfoUser.Database
        }


        let insertChestionar = await this.ws.insert('chestionare', chestionar)


        if(insertChestionar.Succes){

           await this.insertIntrebare(insertChestionar.Content[0].id)

            this.props.history.push(`/chestionardetalii/${insertChestionar.Content[0].id}/${this.props.match.params.idsesiune}/${this.props.match.params.tip}`)


        }

        console.log('chestionar :>> ', chestionar);
    }


    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}

                />
                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>Creeaza un Chestionar Nou </h1>
                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>


                            <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        id='chestionarNou'
                                        style={{ width: '90%' }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='titlu'
                                        value={this.state.titlu || ''}
                                        placeholder='Nume Chestionar'
                                        onChange={(ev) => { this.setState({ titlu: ev.target.value }) }}
                                    />




                                    <label className='inputLabelPM' htmlFor='chestionarNou'>Nume Chestionar</label>

                                </div>
                            </Grid>



                            <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Button style={{ padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.addChestionar}  >
                                    <i className='material-icons pm-round-button-text'>add</i>
                                   Creeaza
                                </Button>
                            </Grid>

                        </Grid>




                    </Grid>
                </Grid>
            </div>
        );
    }
}